import React from "react";
import { find } from "lodash";
import { AICC_STT_ROLE, AiccSttOption, AiccSttRole } from "types/model/aiccLearningAssets";

/**
 * 🔴 THE ENGINE LIST IS GONE FROM THIS FILE. It held four engines with hand-written names, modes and
 * descriptions, and it had drifted from the backend registry it was copying:
 *
 *   - it offered `openai_gpt4o_transcribe_realtime`, which the backend RETIRED — a room degrades that id
 *     to `openai_gpt_transcribe_realtime` and logs it, so this screen named an engine no conversation used;
 *   - it was MISSING `openai_gpt_transcribe_realtime` and `openai_gpt_transcribe_batch`, the two that
 *     replace it — and the batch one is what new languages are created with, so a new language's fallback
 *     printed as a raw id;
 *   - it called the realtime gpt-4o engine "Default fallback". The default fallback is the BATCH one.
 *
 * `GET /api/admin/stt/models` answers all of it — names, prose, modes, which slot each is the default for,
 * and which are deprecated — via `useAiccSttModels`. What stays here is this screen's own copy.
 */
/** The name to print for a stored id, falling back to the id for one the catalogue no longer offers. */
export const getSttOptionName = (options: AiccSttOption[], key?: string) => find(options, { key })?.displayName ?? key;

export const STT_DEFAULT_PRIMARY_SUFFIX = "default primary";

export const STT_DEFAULT_FALLBACK_SUFFIX = "default fallback";

/** Said where the catalogue could not be read: the dropdowns are empty, and that needs explaining. */
export const STT_CATALOGUE_UNAVAILABLE =
  "Could not load the STT engine catalogue, so no engines can be offered. Reload to try again.";

export const STT_FIELD_GUIDE_INTRO = (
  <>
    <div>
      {"Converts learner’s spoken audio into text so the AI can understand what they said. It handles " +
        "mixed-language input (e.g., English and Spanish in the same sentence)."}
    </div>
    <div>
      {"Primary is tried first; fallback runs when primary fails. Both must share the same mode (realtime or " +
        "batch). New languages are created with the batch defaults already set."}
    </div>
  </>
);

export const STT_AVAILABLE_OPTIONS_TITLE = "Available Options";

export const STT_ACTIVE_CONFIGURATION_TITLE = "Active Configuration";

export const STT_ROLE_NAME: Record<AiccSttRole, string> = {
  [AICC_STT_ROLE.primary]: "Primary STT",
  [AICC_STT_ROLE.fallback]: "Fallback STT",
};
